module.exports = __webpack_public_path__ + "img/10_israel-andrade.61032717.jpg";